import classNames from 'classnames';
import { BaseCard, BaseCardProps } from '~/components/Card';
import './NftCard.scss';

export type NftCardProps = BaseCardProps & {
  direction?: 'column' | 'row';
};
export const NftCard = ({ className, shadow = true, direction, ...cardProps }: NftCardProps) => (
  <BaseCard
    className={classNames(
      'nft-card',
      {
        [`nft-card-direction-${direction}`]: direction,
      },
      className
    )}
    shadow={shadow}
    {...cardProps}
  />
);
